import React, {Component} from "react";
import './NouveauEtudiant.css'

class NouveauEtudiant extends Component {
	state = {
        numero_etudiant: "",
        prenom_ar: "",
        nom_ar: "",
        prenom_fr: "",
        nom_fr: "",
        date_naissance: "",
        lieu_naissance: "",
        pere: "",
        mere: "",
        adresse: "",
        email: "",
        numero_bac: "",
        annee_bac: "",
        branche_bac: "",
        moyenne_bac: "",
        montion_bac: "",
        cycle: "",
        annee_actuelle: "",
        specialite_generale: "",
        specialite_speciale: "",
        section: "",
        groupe: "",
        sous_groupe: ""
	}

    stringContainsNumber(_string) {
        return /\d/.test(_string);
    }

    declancherAlert = (message) => {
        let alert = document.getElementsByClassName('alert')[0]
        alert.innerHTML = message
        alert.style.display = "block"
        setTimeout(function(){ alert.style.display = "none"; }, 2000);
    }


    enregistrer = (e) => {
		e.preventDefault()
        let ok = true

        if(this.state.sous_groupe.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار المجموعة الجزئية")
        }

        if(this.state.groupe.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار الفوج")
        }

        if(this.state.section.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار المجموعة")
        }

        if(this.state.specialite_generale.length === 0) {
            this.setState({specialite_generale: "جذع مشترك رياضيات وإعلام آلي"})
        }

        if(this.state.annee_actuelle.length === 0) {
            this.setState({annee_actuelle: "السنة الأولى"})
        }

        if(this.state.cycle.length === 0) {
            this.setState({cycle: "ليسانس"})
        }

        if(this.state.montion_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من التقدير")
        }

        if(this.state.moyenne_bac.length === 0 || parseInt(this.state.moyenne_bac) <0 || parseInt(this.state.moyenne_bac) > 20) {
            ok = false
            if(parseInt(this.state.moyenne_bac) <0 || parseInt(this.state.moyenne_bac) > 20)
                this.declancherAlert("معدل البكالوريا يجب أن يكون أكبر من 0 أو أصغير من 20")
            else
                this.declancherAlert("يرجى التحقق من معدل البكالوريا")
        }

        if(this.state.branche_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من شعبة البكالوريا")
        }

        if(this.state.annee_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من دورة البكالوريا")
        }

        if(this.state.numero_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من رقم البكالوريا")
        }

        if(this.state.adresse.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من العنوان")
        }

        if(this.state.mere.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من اسم ولقب الأم")
        }

        if(this.state.pere.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من اسم الأب")
        }

        if(this.state.lieu_naissance.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من مكان الإزدياد")
        }

        if(this.state.date_naissance.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من تاريخ الإزدياد")
        }

        if(this.state.nom_fr.length === 0 || this.stringContainsNumber(this.state.nom_fr)) {
            ok = false
            this.declancherAlert("يرجى التحقق من اللقب بالفرنسية")
        }

        if(this.state.prenom_fr.length === 0 || this.stringContainsNumber(this.state.prenom_fr)) {
            ok = false
            this.declancherAlert("يرجى التحقق من الإسم بالفرنسية")
        }

        if(this.state.nom_ar.length === 0 || this.stringContainsNumber(this.state.nom_ar)) {
            ok = false
            this.declancherAlert("يرجى التحقق من اللقب بالعربية")
        }

        if(this.state.prenom_ar.length === 0 || this.stringContainsNumber(this.state.prenom_ar)) {
            ok = false
            this.declancherAlert("يرجى التحقق من الإسم بالعربية")
        }

        if(ok) {
            ok = false
            let tt = document.getElementsByClassName('alert-success')[0]
            tt.innerHTML  = "تم تسجيل الطالب بنجاح"
            tt.style.display  = "block"
            setTimeout(function(){ tt.style.display = "none"; }, 2000);

            document.getElementsByName('prenom_ar')[0].value= ""
            document.getElementsByName('nom_ar')[0].value= ""
            document.getElementsByName('prenom_fr')[0].value= ""
            document.getElementsByName('nom_fr')[0].value= ""
            document.getElementsByName('date_naissance')[0].value= ""
            document.getElementsByName('lieu_naissance')[0].value= ""
            document.getElementsByName('pere')[0].value= ""
            document.getElementsByName('mere')[0].value= "ذكر"
            document.getElementsByName('adresse')[0].value= ""
            document.getElementsByName('email')[0].value= ""

            document.getElementsByName('numero_bac')[0].value= ""
            document.getElementsByName('annee_bac')[0].value= ""
            document.getElementsByName('branche_bac')[0].value= ""
            document.getElementsByName('moyenne_bac')[0].value= ""
            document.getElementsByName('montion_bac')[0].value= ""
            document.getElementsByName('section')[0].value= ""
            document.getElementsByName('groupe')[0].value= ""
            document.getElementsByName('sous_groupe')[0].value= ""
        }
	}

    prenom_ar_change = (e) => { this.setState({ prenom_ar: e.target.value }) }
    nom_ar_change = (e) => { this.setState({ nom_ar: e.target.value }) }
    prenom_fr_change = (e) => {
	    let prenom = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
	    this.setState({ prenom_fr: prenom })
        e.target.value = prenom
	}
    nom_fr_change = (e) => {
	    this.setState({ nom_fr: e.target.value.toUpperCase() })
        e.target.value = e.target.value.toUpperCase()
	}
    date_naissance_change = (e) => { this.setState({ date_naissance: e.target.value }) }
    lieu_naissance_change = (e) => { this.setState({ lieu_naissance: e.target.value }) }
    pere_change = (e) => {
        let pere = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
        this.setState({ pere: pere })
        e.target.value = pere
	}
    mere_change = (e) => {
        let mere = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
        this.setState({ mere: mere })
        e.target.value = mere
	}
    adresse_change = (e) => { this.setState({ adresse: e.target.value }) }
    email_change = (e) => { this.setState({ email: e.target.value }) }
    numero_bac_change = (e) => { this.setState({ numero_bac: e.target.value }) }
    annee_bac_change = (e) => { this.setState({ annee_bac: e.target.value }) }
    branche_bac_change = (e) => { this.setState({ branche_bac: e.target.value }) }
    moyenne_bac_change = (e) => {
	    this.setState({ moyenne_bac: e.target.value })
        if(parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) < 12) {
            document.getElementsByName('montion_bac')[0].value = "مقبول"
            this.setState({ montion_bac: "مقبول" })
        }
        if(parseFloat(e.target.value) >= 12 && parseFloat(e.target.value) < 14) {
            document.getElementsByName('montion_bac')[0].value = "قريب من الجيد"
            this.setState({ montion_bac: "قريب من الجيد" })
        }
        if(parseFloat(e.target.value) >= 14 && parseFloat(e.target.value) < 16) {
            document.getElementsByName('montion_bac')[0].value = "جيد"
            this.setState({ montion_bac: "جيد" })
        }
        if(parseFloat(e.target.value) >= 16 && parseFloat(e.target.value) < 18) {
            document.getElementsByName('montion_bac')[0].value = "جيد جدا"
            this.setState({ montion_bac: "جيد جدا" })
        }
        if(parseFloat(e.target.value) >= 18 && parseFloat(e.target.value) <= 20) {
            document.getElementsByName('montion_bac')[0].value = "ممتاز"
            this.setState({ montion_bac: "ممتاز" })
        }
        if(parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > 20) {
            document.getElementsByName('montion_bac')[0].value = "اختر التقدير"
            this.setState({ montion_bac: "" })
        }
	}
    montion_bac_change = (e) => { this.setState({ montion_bac: e.target.value }) }
    cycle_change = (e) => { this.setState({ cycle: e.target.value }) }
    annee_actuelle_change = (e) => { this.setState({ annee_actuelle: e.target.value }) }
    specialite_generale_change = (e) => { this.setState({ specialite_generale: e.target.value }) }
    section_change = (e) => { this.setState({ section: e.target.value }) }
    groupe_change = (e) => { this.setState({ groupe: e.target.value }) }
    sous_groupe_change = (e) => { this.setState({ sous_groupe: e.target.value }) }

    render() {
        return(
            <div className="container-nouveau-etudiant">
               <h2>إضافة طالب جديد</h2>
               <div className="sous-container-nouveau-etudiant">

                   <form className="form-n">
                       <fieldset>
                           <legend>المعلومات الشخصية</legend>
                       <div className="row">
                           <div className="col3">
                               <label>الإسم باللغة العربية<span className="required">*</span></label>
                               <input type="text" name="prenom_ar" onChange={this.prenom_ar_change} className="field-divided" placeholder="الإسم" />
                           </div>
                           <div className="col3">
                               <label>اللقب باللغة العربية<span className="required">*</span></label>
                               <input type="text" name="nom_ar" onChange={this.nom_ar_change} className="field-divided" placeholder="اللقب" />
                           </div>
                           <div className="col3">
                               <label>الإسم باللغة الفرنسية<span className="required">*</span></label>
                               <input dir="ltr" type="text" name="prenom_fr" onChange={this.prenom_fr_change} className="field-divided" placeholder="Le prénom" />
                           </div>
                       </div>

                       <div className="row">
                           <div className="col3">
                               <label>اللقب باللغة الفرنسية<span className="required">*</span></label>
                               <input dir="ltr" type="text" name="nom_fr" onChange={this.nom_fr_change} className="field-divided" placeholder="Le nom de famille" />
                           </div>
                           <div className="col3">
                               <label>تاريخ الإزدياد<span className="required">*</span></label>
                               <input type="date" name="date_naissance" onChange={this.date_naissance_change} className="field-divided"/>
                           </div>
                           <div className="col3">
                               <label>مكان الإزدياد<span className="required">*</span></label>
                               <input type="text" name="lieu_naissance" onChange={this.lieu_naissance_change} className="field-divided" placeholder="مكان الإزدياد" />
                           </div>
                       </div>

                       <div className="row">
                           <div className="col3">
                               <label>إسم الأب<span className="required">*</span></label>
                               <input type="text" name="pere" onChange={this.pere_change} className="field-divided" placeholder="إسم الأب" />
                           </div>
                           <div className="col3">
                               <label>إسم ولقب الأم<span className="required">*</span></label>
                               <input type="text" name="mere" onChange={this.mere_change} className="field-divided" placeholder="إسم ولقب الأم" />
                           </div>
                           <div className="col3">
                               <label>العنوان<span className="required">*</span></label>
                               <input type="text" name="adresse" onChange={this.adresse_change} className="field-divided" placeholder="العنوان" />
                           </div>
                       </div>

                       <div className="row">
                           <div className="col3">
                               <label>الإيميل</label>
                               <input type="email" name="email" onChange={this.email_change} className="field-divided" placeholder="الإيميل" />
                           </div>
                           <div className="col3"></div>
                           <div className="col3"></div>
                       </div>
                       </fieldset>
                       <fieldset>
                           <legend>معلومات شهادة البكالوريا</legend>
                           <div className="row">
                               <div className="col3">
                                   <label>رقم شهادة البكالوريا<span className="required">*</span></label>
                                   <input type="number" name="numero_bac" onChange={this.numero_bac_change} className="field-divided" placeholder="رقم الشهادة" />
                               </div>
                               <div className="col3">
                                   <label>الدورة<span className="required">*</span></label>
                                   <select name="annee_bac" onChange={this.annee_bac_change} className="field-divided">
                                       <option value="">اختر الدورة</option>
                                       <option value="2021">2021</option>
                                       <option value="2020">2020</option>
                                       <option value="2019">2019</option>
                                       <option value="2018">2018</option>
                                   </select>
                               </div>
                               <div className="col3">
                                   <label>الشعبة<span className="required">*</span></label>
                                   <select name="branche_bac" onChange={this.branche_bac_change} className="field-divided">
                                       <option value="">اختر الشعبة</option>
                                       <option value="علوم تجريبية">علوم تجريبية</option>
                                       <option value="الرياضيات">رياضيات</option>
                                       <option value="تقني رياضي">تقني رياضي</option>
                                       <option value="تسيير واقتصاد">تسيير واقتصاد</option>
                                   </select>
                               </div>
                           </div>

                           <div className="row">
                               <div className="col3">
                                   <label>المعدل<span className="required">*</span></label>
                                   <input type="number" name="moyenne_bac" onChange={this.moyenne_bac_change} className="field-divided" placeholder="المعدل" />
                               </div>
                               <div className="col3">
                                   <label>التقدير<span className="required">*</span></label>
                                   <select name="montion_bac" onChange={this.montion_bac_change} className="field-divided">
                                       <option value="">اختر التقدير</option>
                                       <option value="مقبول">مقبول</option>
                                       <option value="قريب من الجيد">قريب من الجيد</option>
                                       <option value="جيد">جيد</option>
                                       <option value="جيد جدا">جيد جدا</option>
                                       <option value="ممتاز">ممتاز</option>
                                   </select>
                               </div>
                               <div className="col3"></div>
                           </div>
                       </fieldset>
                       <fieldset>
                           <legend>معلومات التمدرس</legend>
                           <div className="row">
                               <div className="col3">
                                   <label>الطور<span className="required">*</span></label>
                                   <select disabled name="cycle" onChange={this.cycle_change} className="field-divided">
                                       <option value="ليسانس">ليسانس</option>
                                       <option value="ماستر">ماستر</option>
                                       <option value="دكتورا">دكتورا</option>
                                   </select>
                               </div>
                               <div className="col3">
                                   <label>السنة الحالية<span className="required">*</span></label>
                                   <select disabled name="annee_actuelle" onChange={this.annee_actuelle_change} className="field-divided">
                                       <option value="السنة الأولى">السنة الأولى</option>
                                       <option value="السنة الثانية">السنة الثانية</option>
                                       <option value="السنة الثالثة">السنة الثالثة</option>
                                   </select>
                               </div>
                               <div className="col3">
                                   <label>التخصص<span className="required">*</span></label>
                                   <select disabled name="specialite_generale" onChange={this.specialite_generale_change} className="field-divided">
                                       <option value="جذع مشترك رياضيات وإعلام آلي">جذع مشترك رياضيات وإعلام آلي</option>
                                   </select>
                               </div>
                           </div>

                           <div className="row">
                               <div className="col3">
                                   <label>المجموعة<span className="required">*</span></label>
                                   <select name="section" onChange={this.section_change} className="field-divided">
                                       <option value="">اختر المجموعة</option>
                                       <option value="A">A</option>
                                       <option value="B">B</option>
                                       <option value="C">C</option>
                                       <option value="D">D</option>
                                       <option value="E">E</option>
                                       <option value="F">F</option>
                                   </select>
                               </div>
                               <div className="col3">
                                   <label>الفوج<span className="required">*</span></label>
                                   <select name="groupe" onChange={this.groupe_change} className="field-divided">
                                       <option value="">الفوج</option>
                                       <option value="1">1</option>
                                       <option value="2">2</option>
                                       <option value="3">3</option>
                                       <option value="4">4</option>
                                       <option value="5">5</option>
                                       <option value="6">6</option>
                                       <option value="7">7</option>
                                       <option value="8">8</option>
                                       <option value="9">9</option>
                                       <option value="10">10</option>
                                   </select>
                               </div>
                               <div className="col3">
                                   <label>الفوج الفرعي<span className="required">*</span></label>
                                   <select name="sous_groupe" onChange={this.sous_groupe_change} className="field-divided">
                                       <option value="">الفوج الفرعي</option>
                                       <option value="1">1</option>
                                       <option value="2">2</option>
                                   </select>
                               </div>
                           </div>
                       </fieldset>

                   <div className="row">

                            <input onClick={this.enregistrer} type="submit" value="تسجيل الطالب" />

                   </div>
                   </form>

               </div>
                <div className="alert-section">
                    <div className="alert" style={{display: "none", position: "absolute", alignItems: "center", bottom: 70, minWidth: "300px"}}>

                    </div>
                    <div className="alert-success" style={{display: "none", position: "absolute", bottom: 70, minWidth: "300px"}}>

                    </div>
                </div>
            </div>

        )
    }
}

export default NouveauEtudiant